<template lang="pug">
  div
    label.checked
      input(type="checkbox" :value="fileId" v-model="isShow" @click="handleChange").checkbox
      span
    e-modal(
        v-if="showModal"
        @close="closeModal"
        @confirm="saveModal"
        title="Название файла"
        :autoHeight="true"
      )
        slot
          div.col
            div.body
              div.col-block
                label Введите название файла
                input(type="text" v-model.lazy="fileName" @focus="focused = true" @blur="focused = false").file-input
</template>

<script>
  import {menuApi} from '../../api/api-endpoints.js'
  export default {
    props: {
      fileId: Number,
      show: Boolean
    },
    data() {
      return {
        isShow: this.show,
        prev: null,
        showModal: false,
        fileName: null,
        focused: false
      };
    },
    methods: {
      handleChange(event) {
        this.prev = this.isShow;
        if(this.isShow) {
          this.remove();
          return;
        }
        this.showModal = true;
        this.isShow = !this.isShow;
      },
      closeModal() {
        this.showModal = false;
        this.isShow = this.prev;
      },
      clear() {
        this.showModal = false;
        this.fileName = null
      },
      remove() {
        this.$e.confirmBox(
          'Значение будет удаленно',
          'Отменить загрузку?'
        ).then(() => {
          this.$bar.start();
          this.$store.dispatch('deleteModel', {
            url: menuApi.one(this.fileId)
          }).then(() => {
            this.$bar.finish();
            this.clear();
          }).catch(er => {
            this.$bar.finish();
            this.clear();
            this.$e.errorBox(er)
          })
        }).catch(() => {
          this.isShow = this.prev;
          this.clear();
        })
      },
      saveModal() {
        this.$bar.start();
        this.$store.dispatch('createModel', {
          url: menuApi.list(),
          data: {
            'file_id': this.fileId,
            'name':  this.fileName
          }
        }).then(() => {
          this.$bar.finish();
          this.clear();
        }).catch(er => {
          this.isShow = this.prev;
          this.$bar.finish();
          this.clear();
          this.$e.errorBox(er)
        })
      }
    },
  }
</script>
<style scoped>
  .file-input {
    margin: 0;
    border: 1px solid #ddd;
  }
</style>
